export const ROUTES = {
  HOME: '/',
  CHECKOUT: '/checkout-payment/:paymentExternalId',
  PAYMENT: '/payment/:paymentExternalId',
  PAYMENT_STATUS: '/payment/:paymentExternalId/status',
  PAYMENT_LINK: '/payment-link/:paymentLinkId',
  GENERIC_ERROR: '/error',
};
